export enum ANDROID_PLAN_IDS {
  ANUAL_PLAN_SUBSCRIPTION = '365_annual_subs_estudaqui',
  QUARTERLY_PLAN_SUBSCRIPTION = '90_quarter_subs_estudaqui',
  MONTLHY_PLAN_SUBSCRIPTION = '30_monthly_subs_estudaqui',
}
